import { Fragment } from 'react';
import type { VFC, ReactNode } from 'react';

import cn from 'classnames';

import * as styles from './Label.module.scss';

const defaultLabels: string[] = [];
interface LabelProps {
  labels?: ReactNode[];
  className?: string;
  separator?: string;
  size?: 'small' | 'medium' | 'large';
  allcaps?: boolean;
}

export const Label: VFC<LabelProps> = ({
  labels = defaultLabels,
  className,
  separator = ' • ',
  size,
  allcaps,
}) => {
  if (labels.length < 1) {
    return null;
  }

  return (
    <div
      data-nosnippet
      className={cn(className, {
        [styles.label]: !className,
        [styles.small]: size === 'small',
        [styles.large]: size === 'large',
        [styles.allcaps]: allcaps,
      })}
    >
      {labels.map((label, i) => (
        <Fragment key={i}>
          <span>{label}</span>
          {i < labels.length - 1 && separator}
        </Fragment>
      ))}
    </div>
  );
};
